// Types
import type { AccessControlDTO, StoreData } from "@hitit/api";
// Utils
import axios from "axios";
import { derived, get, writable } from "svelte/store";
import { api } from "@hitit/hub/src/stores";
import { localStore } from "@hitit/utils";



export const storeIds = localStore("storeIds");
export const allStoreMode = derived(storeIds, (v) => v.split("|").length >= 2)
export const stores = () => {
    const { subscribe, set, update } = writable<StoreData[] | undefined>(undefined)
    const updateStores = async (storeIds: string[]) => {
        const API = get(api)
        const getStoreResponse = storeIds.map((v) => API.getStore(v))
        const responses = await Promise.all(getStoreResponse)
        const stores = responses.map((v) => v.data.result[0]);
        set(stores);
    }
    return {
        updateStores,
        subscribe,
        set,
        update
    }
}
export const accessControls = () => {
    const { subscribe, set, update } = writable<AccessControlDTO[] | undefined>(undefined)
    const updateAccessControl = async () => {
        const API = get(api)
        const getAccessControl = await API.getAccessControlByToken();
        const accessControlList = getAccessControl.data.accessControlListDTO.accessControlDTOList
        set(accessControlList);
    }
    return {
        updateAccessControl,
        subscribe,
        set,
        update
    }
}


export const accessControlList = accessControls()
export const fullStoreList = stores()
export const storelogoImages = () => {
    const imageStore = writable<{ image: string, storeId: string }[] | undefined>(undefined)
    const { subscribe, update, set } = imageStore
    const defaultImage = "/Icons/StoreDefaultIcon.png"

    async function getStoreLogos(id: string[]) {
        const promises = id.map((storeId) => {
            const url = `${"HITIT_IMAGE_URL"}logo/${storeId}.png?v=${Date.now()}`;
            return new Promise(async (resolve) => {
                try {
                    const response = await axios.get(url, {
                        withCredentials: true,
                        responseType: "blob",
                    });
                    if (!response.data) {
                        throw new Error("None Data")
                    } else {
                        const image = URL.createObjectURL(response.data)
                        resolve({
                            storeId,
                            image
                        })
                    }
                } catch (error) {
                    resolve({
                        storeId,
                        image: defaultImage
                    })
                }
            })
        })
        const responses = await Promise.all(promises) as { storeId: string, image: string }[];
        set(responses)
    }

    async function refreshStoreLogos() {
        const accessControls = get(accessControlList)
        if (accessControls === undefined) {
            return;
        }

        const storeIds = accessControls.map((v) => v.storeId);
        await getStoreLogos(storeIds)
    }

    function getDefaultImage() {

        return defaultImage
    }

    accessControlList.subscribe(async (accessContorls) => {
        if (accessContorls === undefined) {
            return;
        }

        const storeIds = accessContorls.map((v) => v.storeId);
        await getStoreLogos(storeIds)
    })



    return {
        getDefaultImage,
        subscribe,
        update,
        refreshStoreLogos,
    }
}
export const storeLogos = storelogoImages()